/**
 * Share of other players at or below the user's round total (from point bucket histogram).
 * @param {number|null|undefined} userTotalPoints
 * @param {Record<string, number>|null|undefined} pointBuckets
 * @returns {{ totalPoints: number, percent: number, totalPlayers: number } | null}
 */
export function computePointsAheadPercent(userTotalPoints, pointBuckets) {
  if (userTotalPoints == null || !pointBuckets || typeof pointBuckets !== 'object') return null;

  const userScore = Number(userTotalPoints);
  if (Number.isNaN(userScore)) return null;

  let totalPlayers = 0;
  let playersAtOrBelow = 0;

  for (const [scoreStr, count] of Object.entries(pointBuckets)) {
    const score = Number(scoreStr);
    const n = Number(count) || 0;
    if (Number.isNaN(score) || n <= 0) continue;
    totalPlayers += n;
    if (score <= userScore) playersAtOrBelow += n;
  }

  if (totalPlayers <= 1) return null;

  const othersTotal = totalPlayers - 1;
  const othersAtOrBelow = Math.max(0, playersAtOrBelow - 1);
  const percent = Math.round((othersAtOrBelow / othersTotal) * 100);

  return { totalPoints: userScore, percent, totalPlayers };
}
